import classNames from "classnames/bind";
import { RhLink } from "@components";
import { getLinkData } from "@/core/utils";

import styles from "./Links.module.scss";
const cx = classNames.bind(styles);

type InlineLinkProps =
  Omit<SiteNavigation["navigationSettingsFields"]["hostEventLink"], '__typename'>;

export default function InlineLink(props: InlineLinkProps) {
  const linkData = getLinkData(props);
  if (!linkData) return null;
  return (
    <RhLink
      className={cx(["inline-link", "text-m"])}
      href={linkData.url}
      target={linkData.target}
      data-gtm-section="nav"
    >
      {linkData.label}
    </RhLink>
  );
}
